import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {getQuote, runQuote} from "shared/networking/quotes";

import {setInputValue, setValid} from "apps/QuoterApp/reduxElements/slices/quoteInput";

import quoteInputSchema from "apps/QuoterApp/validation/quoteInputSchema";


export const setInputValueAndRunQuote = createAsyncThunk(
    'setValueAndRequest',
    async (input, {dispatch, getState, rejectWithValue, signal}) => {
        await dispatch(setInputValue(input));

        const {quoteInput: {data}} = getState();

        try {
            await quoteInputSchema.validate(data);
            await dispatch(setValid(true));
        } catch (e) {
            await dispatch(setValid(false));
            return rejectWithValue(e.message || e);
        }

        try {
            const urlParams = new URLSearchParams(window.location.search);
            const allowTickets = urlParams.get('allowTickets') !== '0';
            const showClientView = urlParams.get('showClientView') !== '0';
            const agentId = urlParams.get('agent') ? parseInt(urlParams.get('agent')) : null;

            const result = await runQuote(data, allowTickets, agentId, showClientView, signal);
            if (result.products.length > 0) {
                await dispatch(selectProduct(result.products[0].id));
            }

            return result;
        } catch (e) {
            return rejectWithValue(e.message || e);
        }
    },
);

export const initQuote = createAsyncThunk(
    'initQuote',
    async (quoteToken, {dispatch, rejectWithValue}) => {

        try {
            const {input, result} = await getQuote(quoteToken);

            await dispatch(setInputValue(input));
            await dispatch(setValid(true));

            if (result.products.length > 0) {
                await dispatch(selectProduct(result.products[0].id));
            }

            return result;
        } catch (e) {
            await dispatch(setValid(false));
            return rejectWithValue(e.message || e);
        }
    },
);

const initialState = {
    loading: 0,
    init: false,
    selectedProduct: undefined,
    showProductDetails: false,
    result: {
        products: [],
    },
};

const quoteRequestSlice = createSlice({
    name: 'quoteRequest',
    initialState,
    reducers: {
        selectProduct: (state, action) => {
            state.selectedProduct = action.payload;
        },
        showProductDetails: (state) => {
            state.showProductDetails = true;
        },
        hideProductDetails: (state) => {
            state.showProductDetails = false;
        },
    },
    extraReducers: {
        [setInputValueAndRunQuote.pending]: (state) => {
            state.loading += 1;
            state.error = undefined;
        },
        [setInputValueAndRunQuote.fulfilled]: (state, action) => {
            state.loading -= 1;
            state.result = action.payload;
            state.error = undefined;
        },
        [setInputValueAndRunQuote.rejected]: (state, action) => {
            state.loading -= 1;
            state.error = action.payload;
        },
        [initQuote.pending]: (state) => {
            state.loading += 1;
            state.error = undefined;
        },
        [initQuote.fulfilled]: (state, action) => {
            state.loading -= 1;
            state.result = action.payload;
            state.init = true;
            state.error = undefined;
        },
        [initQuote.rejected]: (state, action) => {
            state.loading -= 1;
            state.error = action.payload;
        },
    },
});

export default quoteRequestSlice.reducer;

export const {selectProduct, showProductDetails, hideProductDetails} = quoteRequestSlice.actions;
